import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problem() {
  return (
    <section className="problem_amj p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="problem_img">
              <StaticImage
                src="../../../images/case-studies/amj/problem_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={514}
                height={664}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>The Problem</h2>
            <p>
              Modern jobs require employees to act agile, and active on their
              toes during the business hours. Deadlines, targets, work pressure,
              or the nature of specific jobs can make employees feel rushed.
              Furthermore, the workspace arrangements, even if they are spacious
              or congested, can drain employees physically.
            </p>
            <p>
              While some employees can make conscious efforts for their physical
              fitness, others may get anxious and overwhelmed at the end of the
              day. This drain can directly affect their physical wellbeing and
              ultimately impact their productivity at work.
            </p>
            <p>
              Building onto this narrative, client wanted to create a fitness
              app that would keep track of employees’ daily activities aimed at
              achieving wellness.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problem;
